import { memo } from 'react';
import { useAsync } from 'react-use';
import {
    IPromotion,
    IRankingTeam,
    ITournament,
} from '@zmedia/bm-soccer-ui/interface';
import { ArrayUtils } from '@zmedia/bm-soccer-ui/utils';
import StandingService from '@zmedia/bm-soccer-ui/service/StandingService';
import {
    Image,
    RouterLink,
    Section,
    Title,
} from '@zmedia/bm-soccer-ui/components';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import { Table, TableGroup } from './components';
import { TitleHeader } from '@zmedia/bm-soccer-ui/modules/shared/components/TitleHeader';
import { TitleWrap } from '@zmedia/bm-soccer-ui/modules/shared/components/TitleWrap';
import styles from './style.module.scss';

export function TournamentRanking(props: any) {
    const { id, seasonId, name, seasonName = '' } = props;
    const params = {
        tournamentId: id,
        seasonId: seasonId,
    };
    let data = props.data;
    if (!props.data) {
        const state = useAsync(
            () => StandingService.getDetail(params),
            [id, seasonId],
        );
        data = state.value?.data || {};
    }

    const items: IRankingTeam[] = data.items || [];
    const groups: any[] = data.groups || [];
    const promotions: IPromotion[] = data.promotions || [];
    const tournament: ITournament = data.tournament || {};

    if (ArrayUtils.isEmpty(items) && ArrayUtils.isEmpty(groups)) {
        return null;
    }

    if (!ArrayUtils.isEmpty(groups)) {
        return (
            <GroupRanking {...props} groups={groups} tournament={tournament} />
        );
    }

    return (
        <Section className={styles['ranking-section']}>
            <TitleHeader>
                <Image src={tournament.logo} alt={tournament.name} />
                <Title renderAs="h2">
                    <RouterLink
                        to={`${URL_SOCCER_PAGE.SUBPATH}${tournament.path}`}
                        title={`BXH ${name || tournament.name} ${seasonName || tournament.currentSeason}`}
                    >
                        <span>
                            BXH {name || tournament.name}{' '}
                            {seasonName || tournament.currentSeason}
                        </span>
                    </RouterLink>
                </Title>
            </TitleHeader>
            <Table {...props} promotions={promotions} items={items} />
        </Section>
    );
}

function GroupRanking(props: any) {
    const {
        groups = [],
        name,
        seasonName = '',
        currentSeason = '',
        tournament,
    } = props;
    return (
        <Section className={styles['ranking-section']}>
            <TitleHeader>
                <Image src={tournament.logo} alt={tournament.name} />
                <TitleWrap
                    title={`BXH ${name || tournament.name} ${
                        (seasonName ? seasonName : currentSeason) ||
                        tournament.currentSeason
                    }`}
                    renderAs="h2"
                ></TitleWrap>
            </TitleHeader>
            <TableGroup groups={groups} />
        </Section>
    );
}

export default memo(TournamentRanking);
